import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d96fca4")

_pushScopeId("data-v-5d96fca4")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { style: {"color":"red","margin-left":"10px"} }, "车辆列表中同步时间小的优先同步，建议至少小于当前时间24小时")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { style: {"color":"red","margin-left":"10px"} }, "仅同步该时间之后发生的违章")
], -1)
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
    width: "600px",
    "before-close": _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.formData,
        "label-width": "auto"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "上次违章同步时间:",
            prop: "lastViolationSyncTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.lastViolationSyncTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.lastViolationSyncTime = $event)),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD HH:mm:ss",
                type: "datetime",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"]),
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "最新违章时间:",
            prop: "lastViolationTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.lastViolationTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.lastViolationTime = $event)),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD HH:mm:ss",
                type: "datetime",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"]),
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})